import * as Yup from "yup";

export default Yup.object({
  course_overview: Yup.string().required("Course overview is required"),
  target_customer_and_pain_points: Yup.string().required(
    "Target customer and pain points are required",
  ),
  expected_outcome: Yup.string().required("Expected outcome is required"),
});
